"use client";

import { useEffect, useState } from "react";
import {
  ADMIN_DEBUG_FLAGS_EVENT,
  type AdminDebugFlagKey,
  type AdminDebugFlagState,
  readAdminDebugFlag,
  readAdminDebugFlags,
} from "@/lib/admin/debugFlags";

export function useAdminDebugFlags(): AdminDebugFlagState {
  const [flags, setFlags] = useState<AdminDebugFlagState>(() => readAdminDebugFlags());

  useEffect(() => {
    const sync = () => setFlags(readAdminDebugFlags());
    sync();
    window.addEventListener(ADMIN_DEBUG_FLAGS_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(ADMIN_DEBUG_FLAGS_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return flags;
}

export function useAdminDebugFlag(key: AdminDebugFlagKey): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => readAdminDebugFlag(key));

  useEffect(() => {
    const sync = () => setEnabled(readAdminDebugFlag(key));
    sync();
    window.addEventListener(ADMIN_DEBUG_FLAGS_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(ADMIN_DEBUG_FLAGS_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [key]);

  return enabled;
}
